import { deepAnalysisApi } from '../service';
import {
    DomainChecks,
    FetchOnPageSeoFailedChecksParams,
    SeoTestDetails,
    FetchOnPageSeoTestParams,
    FetchAllOnPageSeoTestsResponse,
    ClusterFailedChecks,
    FetchOnPageSeoWebsiteFailedChecksParams,
    AffectedCluster,
    FetchAffectedClustersParams,
    FetchAffectedUrlsResponse,
    FetchAffectedUrlsParams,
} from './types';

const failedChecksApi = deepAnalysisApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchOnPageWebsiteFailedChecks: builder.query<ClusterFailedChecks[], FetchOnPageSeoWebsiteFailedChecksParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/website-failed-checks/${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'FailedChecks', id: args.w_guid }],
        }),

        fetchOnPageSeoDomainChecks: builder.query<DomainChecks, FetchOnPageSeoFailedChecksParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/domain-checks/${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'DomainChecks', id: args.w_guid }],
        }),

        fetchAllOnPageSeoTests: builder.query<FetchAllOnPageSeoTestsResponse, void>({
            query: () => {
                return {
                    method: 'GET',
                    url: '/on-page-seo/seo-test',
                };
            },
        }),

        fetchOnPageSeoTestDetails: builder.query<SeoTestDetails, FetchOnPageSeoTestParams>({
            query: (args) => {
                const { seo_test_key } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/seo-test/${seo_test_key}`,
                };
            },
        }),

        fetchAffectedClusters: builder.query<AffectedCluster[], FetchAffectedClustersParams>({
            query: (args) => {
                const { w_guid, seo_test_key } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/affected-clusters/${w_guid}/${seo_test_key}`,
                };
            },

            providesTags: (result, error, args) => [
                { type: 'AffectedUrls', id: `${args.w_guid}_${args.seo_test_key}` },
                { type: 'AffectedUrls', id: args.w_guid },
            ],
        }),

        fetchAffectedUrls: builder.query<FetchAffectedUrlsResponse, FetchAffectedUrlsParams>({
            query: (args) => {
                const { w_guid, cluster_guid, seo_test_key, limit, last_evaluated_key } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/affected-urls/${w_guid}/${cluster_guid}/${seo_test_key}${limit ? `?limit=${limit}` : ''}${last_evaluated_key ? `&last_evaluated_key=${last_evaluated_key}` : ''
                        }`,
                };
            },

            providesTags: (result, error, args) => [
                { type: 'AffectedUrls', id: `${args.w_guid}_${args.seo_test_key}` },
                { type: 'AffectedUrls', id: args.w_guid },
            ],
        }),
    }),
});

export const {
    useFetchAllOnPageSeoTestsQuery,
    useFetchOnPageSeoTestDetailsQuery,
    useLazyFetchAffectedUrlsQuery,
    useFetchOnPageSeoDomainChecksQuery,
    useFetchAffectedClustersQuery,
    useFetchOnPageWebsiteFailedChecksQuery,
} = failedChecksApi;
